export default __webpack_public_path__ + "assets/4b3e9ba0bf0db863220b6e728b012ade.svg";